import React from 'react';
import { Container, Typography, Paper } from '@mui/material';
import { useTranslation } from 'react-i18next';
import UserListPage from './UserListPage';

// Thin wrapper to reuse UserListPage for receptionists
const ReceptionistMembersPage = () => {
  const { t } = useTranslation();
  return (
    <Container maxWidth="xl" sx={{ py: 3 }}>
      <Typography variant="h4" gutterBottom>
        {t('receptionist:members.title')}
      </Typography>
      <Paper sx={{ p: 2 }}>
        <UserListPage />
      </Paper>
    </Container>
  );
};

export default ReceptionistMembersPage;

